import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "anchor-bottom" };
const _hoisted_3 = { key: 1 };
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import MGWalletStack from './elements/MGWalletStack.vue';
import SpendingPotButton from './elements/SpendingPotButton.vue';
import AwaitVoucherPanel from './elements/AwaitVoucherPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WalletPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getDiscountsStatement, getCustomerVouchers, clearCustomerVouchers } = useVouchers();
        const balance = ref(0);
        const discountsStatement = ref(null);
        const polling = ref(false);
        let pollTimeout = null;
        let pollCount = 0;
        let lastVoucherCount = 0;
        let pollActive = false;
        const savedToSpendBalance = computed(() => {
            return discountsStatement.value?.savedToSpendBalance || 0;
        });
        const activeVouchers = computed(() => {
            const filteredVouchers = state.vouchers?.vouchers;
            // If no active vouchers, add a skeleton voucher
            if (filteredVouchers.length === 0) {
                const skeletonVoucher = {
                    id: 'skeleton-voucher',
                    currentBalance: 0,
                    discount: {
                        merchant: {
                            id: 'skeleton-merchant',
                            name: '',
                            logoUrl: '',
                            categories: ''
                        },
                        cardColour: '#E9E6E2',
                        online: false,
                        inStore: false
                    },
                    customerVoucherTransactions: [],
                    isSkeleton: true
                };
                return [skeletonVoucher];
            }
            return filteredVouchers;
        });
        function pollVouchers() {
            if (!pollActive || pollCount >= 5) {
                pollActive = false;
                polling.value = false;
                return;
            }
            const delay = pollCount === 0 ? 600 : 2000;
            pollTimeout = setTimeout(() => {
                if (!pollActive)
                    return;
                getCustomerVouchers(() => {
                    if (!pollActive)
                        return;
                    balance.value = state.vouchers.vouchers.reduce((a, b) => a + b.currentBalance, 0);
                    pollCount++;
                    console.log(`Polling attempt ${pollCount}, found ${state.vouchers.vouchers.length} vouchers (last count: ${lastVoucherCount})`);
                    if (state.vouchers.vouchers.length > lastVoucherCount) {
                        pollActive = false;
                        polling.value = false;
                        return;
                    }
                    polling.value = true;
                    pollVouchers();
                }, null, false);
            }, delay);
        }
        function cancelPolling() {
            pollActive = false;
            polling.value = false;
            if (pollTimeout) {
                clearTimeout(pollTimeout);
                pollTimeout = null;
            }
        }
        async function onLoad() {
            clearCustomerVouchers();
            state.vouchers = null;
            getCustomer();
            getDiscountsStatement((result) => {
                discountsStatement.value = result;
            });
            const wantsPoll = route.query.poll === 'true';
            const prev = parseInt(route.query.prev, 10);
            getCustomerVouchers(() => {
                balance.value = state.vouchers.vouchers.reduce((a, b) => a + b.currentBalance, 0);
                lastVoucherCount = state.vouchers.vouchers.length;
                if (!wantsPoll)
                    return;
                if (!isNaN(prev) && lastVoucherCount > prev)
                    return;
                if (!isNaN(prev))
                    lastVoucherCount = prev;
                pollActive = true;
                pollCount = 0;
                pollVouchers();
            }, null, false);
        }
        onMounted(() => {
            onLoad();
        });
        onBeforeUnmount(() => {
            if (pollTimeout) {
                clearTimeout(pollTimeout);
                pollTimeout = null;
            }
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Vouchers",
                    bgcolor: "white"
                }),
                _createVNode(SpendingPotButton, {
                    amount: savedToSpendBalance.value,
                    onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/SavedToSpend'))),
                    class: "spending-pot-button"
                }, null, 8, ["amount"]),
                _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "title" }, "My Vouchers", -1)),
                _createVNode(AwaitVoucherPanel, {
                    polling: polling.value,
                    onCancel: cancelPolling
                }, null, 8, ["polling"]),
                (_unref(state).customer && _unref(state).vouchers)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(MGWalletStack, {
                            class: "wallet-stack",
                            allActiveVouchers: activeVouchers.value,
                            formatter: _unref(state).formatter,
                            showInitialReveal: false
                        }, null, 8, ["allActiveVouchers", "formatter"]),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { style: { "clear": "both", "margin-bottom": "200px" } }, null, -1)),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_v_row, { class: "button-row" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_col, { class: "button-col" }, {
                                        default: _withCtx(() => [
                                            _createVNode(MGButton, {
                                                arrow: true,
                                                stacked: true,
                                                text: "Buy Vouchers",
                                                fullWidth: "true",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (_unref(router).push({ path: '/shopvouchers' })))
                                            }),
                                            _createVNode(MGButton, {
                                                arrow: true,
                                                stacked: true,
                                                outline: true,
                                                text: "Archived Vouchers",
                                                fullWidth: "true",
                                                onClick: _cache[2] || (_cache[2] = ($event) => (_unref(router).push({ path: '/MyVouchers/Archived/Merchants' })))
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                            return _createElementVNode("div", {
                                key: i,
                                class: "mb-2"
                            }, [
                                _createVNode(_component_v_skeleton_loader, { type: "list-item-avatar-two-line" })
                            ]);
                        }), 64))
                    ]))
            ], 64));
        };
    }
});
